import { useEffect,  useState } from "react";
import "./sass/main.css";
import { Tabs } from '../../elements/tabs/Tabs';
import { TexTranslate, TexTranslateDefault } from '../../../translations/FlattenMessages';
import { FormattedMessage, useIntl } from 'react-intl';
import { Summaries } from "../../UI/summaries/Summaries.jsx";
import { useLoader } from "../../../hooks/useLoader";
import { useSummaries } from "../../../hooks/useSummaries";
import { Banner } from "../banner/Banner";

export const Main = ({menu}) => {

  const intl = useIntl();

  const txtLoad = TexTranslateDefault(intl, "general.Loading...");
  const {showLoader, hideLoader} = useLoader({"textLoader" : txtLoad});

  const {arrayDataSourcing, arrayDataTaxes, arrayDataProcurement, arrayDataFinancing, arrayDataCollection} = useSummaries();
  
  const isDataSourcing = Object.keys(arrayDataSourcing).some(key => arrayDataSourcing[key] !== null && Object.keys(arrayDataSourcing[key]).length>0); //Menú Proveedor
  const isDataTaxes = Object.keys(arrayDataTaxes).some(key => arrayDataTaxes[key] !== null && Object.keys(arrayDataTaxes[key]).length>0); //Menú Proveedor
  const isDataProcurement = Object.keys(arrayDataProcurement).some(key => arrayDataProcurement[key] !== null && Object.keys(arrayDataProcurement[key]).length>0); //Menú Proveedor
  const isDataFinancing = Object.keys(arrayDataFinancing).some(key => arrayDataFinancing[key] !== null && Object.keys(arrayDataFinancing[key]).length>0); //Menú Proveedor
  const isDataCollection = Object.keys(arrayDataCollection).some(key => arrayDataCollection[key] !== null && Object.keys(arrayDataCollection[key]).length>0); //Menú Cliente

  let isEmptySummary = true;
  let tabView = "";

  if(isDataSourcing || isDataTaxes || isDataProcurement  || isDataFinancing || isDataCollection){
    isEmptySummary = false;
  }

  if(menu!=='menuClients' && (isDataSourcing && !isEmptySummary)){
    tabView = 'tab1';
  }else if(menu!=='menuClients' && (isDataProcurement && !isEmptySummary)){
    tabView = 'tab2';
  }else if(menu!=='menuClients' && (isDataFinancing && !isEmptySummary)){
    tabView = 'tab3';
  }else if (menu!=='menuClients' && (isDataTaxes && !isEmptySummary)){
    tabView = 'tab4';
  }else if(menu!=='menuProviders' && (isDataCollection && !isEmptySummary)){
    tabView = 'tab5';
  }else if(isEmptySummary){
    tabView = 'tabDefault';
  }
  
  const [activeTab, setActiveTab] = useState(tabView);
 


  const handleChangeTab = (id) => {
    setActiveTab(id);
  }

  const summariesEmpty = () => {
    return (
      <div className="nonSummaries">
          <div>
            <i className="bi bi-info-circle" />
            <p className="mb-0 fs-3"><FormattedMessage id={"general.We are working on something new to improve your experience in iProveedor soon in this section you will find the summary of your services"} defaultMessage={"We are working on something new to improve your experience in iProveedor soon in this section you will find the summary of your services"} /></p>
          </div>
      </div>
    )
  }

  useEffect(() => {
    showLoader();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isDataLoaderSourcing = Object.keys(arrayDataSourcing).some(key => arrayDataSourcing[key] !== null);
    const isDataLoaderTaxes = Object.keys(arrayDataTaxes).some(key => arrayDataTaxes[key] !== null);
    const isDataLoaderProcurement = Object.keys(arrayDataProcurement).some(key => arrayDataProcurement[key] !== null);
    const isDataLoaderFinancing = Object.keys(arrayDataFinancing).some(key => arrayDataFinancing[key] !== null);
    const isDataLoaderCollection = Object.keys(arrayDataCollection).some(key => arrayDataCollection[key] !== null);

    if (isEmptySummary || isDataLoaderSourcing || isDataLoaderTaxes || isDataLoaderProcurement  || isDataLoaderFinancing || isDataLoaderCollection) {
     hideLoader();
     if(menu!=='menuClients' && (isDataSourcing && !isEmptySummary)){
      if(activeTab !== tabView) {
        setActiveTab("tab1");
      }
    }else if(menu!=='menuClients' && (isDataProcurement && !isEmptySummary)){
      if(activeTab !== tabView) {
        setActiveTab("tab2");
      }
    }else if(menu!=='menuClients' && (isDataFinancing && !isEmptySummary)){
      if(activeTab !== tabView) {
        setActiveTab("tab3");
      }
    }else if(menu!=='menuClients' && (isDataTaxes && !isEmptySummary)){
      if(activeTab !== tabView) {
        setActiveTab("tab4");
      }
    }else if(menu!=='menuProviders' && (isDataCollection && !isEmptySummary)){
      if(activeTab !== tabView) {
        setActiveTab("tab5");
      }
    }else if(isEmptySummary){
      if(activeTab !== tabView) {
        setActiveTab("tabDefault");
      }
    }
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayDataSourcing, arrayDataTaxes,  arrayDataProcurement, arrayDataFinancing, arrayDataCollection]);

    useEffect(() => {
      
      if(tabView!==activeTab && (activeTab === "" || activeTab === "tabDefault" 
        || ( menu==='menuProviders' && (activeTab !=='tab1' && activeTab !=='tab2' && activeTab !=='tab3' && activeTab !=='tab4')) || (menu ==='menuClients' && (activeTab !=='tab5')))){
        if(tabView === ""){
          setActiveTab("tabDefault");
        }else{
          setActiveTab(tabView);
        }

      }
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabView, menu]);

  return (
    <>
        <div className="content">
            { isEmptySummary === null ? <></> : !isEmptySummary ?
              <>
                <div className="rowx tabMenu">
                  <div className="colx-12 contentTabMenu">
                    <Tabs handleChangeTab={handleChangeTab} dataContent={
                          [{ name: TexTranslate(intl, "sourcing.sourcing"), id: "tab1", active: (activeTab === "tab1"), visible:(isDataSourcing && menu!=='menuClients'), key: 1 },
                          { name: TexTranslate(intl, "Procurement.Procurement"), id: "tab2", active: (activeTab === "tab2"), visible:( isDataProcurement && menu!=='menuClients'), key: 2 },
                          { name: TexTranslate(intl, "Financing.Financing"), id: "tab3", active: (activeTab === "tab3"), visible:(isDataFinancing && menu!=='menuClients'), key: 3 },
                          { name: TexTranslate(intl, "Taxes.Taxes"), id: "tab4", active: (activeTab === "tab4"), visible:(isDataTaxes && menu!=='menuClients'), key: 4 },
                          { name: TexTranslate(intl, "Collection.Collection"), id: "tab5", active: (activeTab === "tab5"), visible:(isDataCollection && menu!=='menuProviders'), key: 5 },
                          { name: TexTranslateDefault(intl, `general.${menu}`), id: "tabDefault", active: (activeTab === "tabDefault"), visible:(activeTab === "tabDefault"), key: 6 }]}
                      />
                  </div>
                </div>
                <div className="rowx content_main withTab">
                    <div className="rowx content_center">
                      <div className="rowx tabContent">
                        <div className="colx-12 colTabContent">
                          {
                              activeTab === 'tab1' &&
                              <>
                              {Object.keys(arrayDataSourcing).map((innerAttr, index) => {
                                  return (
                                      <Summaries key={`smtb1-${index}`} jsonDataSummaries={arrayDataSourcing[innerAttr]} dictionary="sourcing" />
                                  )})
                              }
                              </>
                              
                          }
                          {
                              activeTab === 'tab2' &&
                              <>
                              {Object.keys(arrayDataProcurement).map((innerAttr, index) => {
                                  return (
                                      <Summaries key={`smtb2-${index}`} jsonDataSummaries={arrayDataProcurement[innerAttr]} dictionary="Procurement" />
                                  )})
                              }
                              </>
                          }
                          {
                              activeTab === 'tab3' &&
                              <>
                              {Object.keys(arrayDataFinancing).map((innerAttr, index) => {
                                  return (
                                      <Summaries key={`smtb3-${index}`} jsonDataSummaries={arrayDataFinancing[innerAttr]} dictionary="Financing" />
                                  )})
                              }
                              </>
                          }
                          {
                              activeTab === 'tab4' &&
                              <>
                              {Object.keys(arrayDataTaxes).map((innerAttr, index) => {
                                  return (
                                      <Summaries key={`smtb2-${index}`} jsonDataSummaries={arrayDataTaxes[innerAttr]} dictionary="Taxes" />
                                  )})
                              }
                              </>
                          }
                          {
                              activeTab === 'tab5' &&
                              <>
                              {Object.keys(arrayDataCollection).map((innerAttr, index) => {
                                  return (
                                      <Summaries key={`smtb4-${index}`} jsonDataSummaries={arrayDataCollection[innerAttr]} dictionary="Collection" />
                                  )})
                              }
                              </>
                          }
                          {
                              activeTab === 'tabDefault' &&
                              
                              summariesEmpty()
                              
                          }
                        </div>
                      </div>
                    </div>
                    <div className="content_right withTab">
                      <Banner/>
                    </div>
                </div>
              </> 
              : 
              <>
              <div className="rowx content_main">
                <div className="rowx content_center">
                  {summariesEmpty()}
                </div>
                <div className="content_right">
                  <Banner/>
                </div>
              </div>
              </>
            }
        </div>
    </>
  )
} 
